import { bytesToNDigits } from '@mail/cross-sizes-utils';
import { isNil } from 'ramda';
import React, { memo } from 'react';

import styles from './Size.css';

export interface SizeProps {
    size?: number;
    maxDigitsCount: number;
}

export const Size = memo(({ size, maxDigitsCount }: SizeProps) => {
    return <div className={styles.root}>{!isNil(size) && bytesToNDigits(size, maxDigitsCount).value}</div>;
});

Size.displayName = 'Size';
